export const reloadWithDifferentCompany = (history, location, companyId) => {
  const pathMatches = location.pathname.match(/^\/[^\/]+\/(.*)/);
  if (!pathMatches) return;

  const currentPath = pathMatches[1];

  history.push(`/${companyId}/${currentPath}`);
};
